// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Pastille de statut : memes valeurs que les listes (Operation.css, Commandes.css), classe partagee. */
.status-badge {
  display: inline-flex;
  align-items: center;
  padding: 0.4rem 1.2rem;
  border-radius: 12px;
  font-size: 1.4rem;
  font-weight: 700;
}

/* Accepte : vert. */
.status-badge.valide,
.status-badge.accepte {
  color: #00a708;
}

/* Termine sans suite : rouge. */
.status-badge.refuse,
.status-badge.expire,
.status-badge.annule {
  color: #d90e0e;
}

/* Une action attend quelqu'un : orange (meme nuance que « Action requise » des listes ; « A relancer »
   garde l'orange de la liste des operations). */
.status-badge.a-accepter,
.status-badge.a-chiffrer {
  color: #f4751b;
}

.status-badge.a-relancer {
  color: #f97316;
}

/* Brouillons et attentes : gris. */
.status-badge.brouillon,
.status-badge.brouillon-acheteur,
.status-badge.brouillon-prestataire,
.status-badge.en-attente-de-loffre,
.status-badge.en-attente-de-lanalyse,
.status-badge.en-attente-de-decision-de-lacheteur,
.status-badge.en-attente-de-lacceptation-du-rang-1,
.status-badge.en-attente-de-lacceptation-du-rang-2,
.status-badge.en-attente-de-lacceptation-du-rang-3 {
  color: #6b7280;
}
`, "",{"version":3,"sources":["webpack://./src/composants/StatutBadge/StatutBadge.css"],"names":[],"mappings":"AAAA,uGAAuG;AACvG;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;;EAEE,cAAc;AAChB;;AAEA,gCAAgC;AAChC;;;EAGE,cAAc;AAChB;;AAEA;gDACgD;AAChD;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,mCAAmC;AACnC;;;;;;;;;EASE,cAAc;AAChB","sourcesContent":["/* Pastille de statut : memes valeurs que les listes (Operation.css, Commandes.css), classe partagee. */\n.status-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.4rem 1.2rem;\n  border-radius: 12px;\n  font-size: 1.4rem;\n  font-weight: 700;\n}\n\n/* Accepte : vert. */\n.status-badge.valide,\n.status-badge.accepte {\n  color: #00a708;\n}\n\n/* Termine sans suite : rouge. */\n.status-badge.refuse,\n.status-badge.expire,\n.status-badge.annule {\n  color: #d90e0e;\n}\n\n/* Une action attend quelqu'un : orange (meme nuance que « Action requise » des listes ; « A relancer »\n   garde l'orange de la liste des operations). */\n.status-badge.a-accepter,\n.status-badge.a-chiffrer {\n  color: #f4751b;\n}\n\n.status-badge.a-relancer {\n  color: #f97316;\n}\n\n/* Brouillons et attentes : gris. */\n.status-badge.brouillon,\n.status-badge.brouillon-acheteur,\n.status-badge.brouillon-prestataire,\n.status-badge.en-attente-de-loffre,\n.status-badge.en-attente-de-lanalyse,\n.status-badge.en-attente-de-decision-de-lacheteur,\n.status-badge.en-attente-de-lacceptation-du-rang-1,\n.status-badge.en-attente-de-lacceptation-du-rang-2,\n.status-badge.en-attente-de-lacceptation-du-rang-3 {\n  color: #6b7280;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
